import React, { useState, useRef, useEffect } from "react";
import "../App.css";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getApiUrl } from "../utils/api"; // your utility to get API URLs

const Header = () => {
  const texts = [
    "🚀 Welcome to BSK Boutique",
    "🔥 Free Shipping on all orders!",
    "💻 Thanks for shopping with us!",
  ];
  const [descriptions, setDescriptions] = useState([]);
 const fetchDescriptions = async () => {
    try {
      const res = await fetch(getApiUrl("sampledescription-list"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });

      const result = await res.json();

      if (result.success) {
        setDescriptions(result.data || []);
      }
    } catch (err) {
      toast.error("Failed to load descriptions");
    }
  };

  useEffect(() => {
    fetchDescriptions();
  }, []);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % texts.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [texts.length]);

 
  useEffect(() => {
    if (!query) return setSuggestions([]);

    const fetchProducts = async () => {
      try {
        const res = await fetch(getApiUrl("product-search"), {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ search: query }),
        });

        const data = await res.json();

        if (data.success) {
          setSuggestions(data.products);
        } else {
          setSuggestions([]);
        }
      } catch (error) {
        console.error(error);
        toast.error("Error fetching products");
      }
    };

    fetchProducts();
  }, [query]);

  const openProductDetail = (product) => {
    if (!product.slugUrl) return toast.error("Product link not available");
    window.open(`${window.location.origin}/${product.slugUrl}`, "_blank");
  };

  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setSuggestions([]);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div>
      <div className="scroll-header bg-light py-1">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-lg-6 d-flex align-items-center justify-content-center justify-content-lg-start gap-2">
              <a href="https://www.instagram.com/bskboutique?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" className="text-white">
                <i className="fa-brands fa-instagram"></i>
              </a>

              <span className="fw-semibold">bskboutique</span>

              <a href="https://wa.me/918668160894" className="text-white">
                <i className="fa-brands fa-whatsapp"></i>
              </a>

              <span>+91 8668160894</span>  
            </div>

            <div className="col-12 col-lg-6 mt-1 mt-lg-0 text-lg-end">
              <marquee behavior="scroll" direction="left" scrollamount="8">
                {descriptions[currentIndex]}
              </marquee>
            </div>
          </div>
        </div>
      </div>

      <div className="jumbo-header fixed-top bg-white shadow-sm">
        <div className="container">
          <div className="row align-items-center py-2">
            <div className="col-lg-7 d-lg-flex d-none align-items-center">
              <div className="col-4 logo-ht d-flex padding-center">
                <a
                  className="navbar-brand fw-bold fs-4 text-dark"
                  href="bsk-home"
                >
                  BSK Boutique
                </a>
              </div>

              <div className="col-2">
                <a href="bsk-home" className="text-link header-text text-dark">
                  Home
                </a>
              </div>

              <div className="col-2">
                <Link
                  to="/bsk-about"
                  className="text-link header-text text-dark"
                >
                  About
                </Link>
              </div>

              <div className="col-3">
                <Link
                  to="/bsk-main-product"
                  className="text-link header-text text-dark"
                >
                  BSK-Products
                </Link>
              </div>

              <div className="col-3 px-1">
                <Link
                  to="/bsk-size-chart"
                  className="text-link header-text text-dark"
                >
                  Size Chart
                </Link>
              </div>
            </div>

            <div className="col-lg-5 col-12 d-flex align-items-center justify-content-end">
              <div
                className="col-7"
                style={{ position: "relative" }}
                ref={dropdownRef}
              >
                <div className="floating-label-group margin-bottom">
                  <input
                    type="text"
                    name="search"
                    placeholder="Search product"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    required
                  />
                  <label>Search Product</label>
                </div>

                
                {suggestions.length > 0 && (
                  <ul
                    className="list-group"
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      zIndex: 1000,
                    }}
                  >
                    {suggestions.map((product) => (
                      <li
                        key={product._id}
                        className="list-group-item list-group-item-action"
                        style={{ cursor: "pointer" }}
                        onClick={() => openProductDetail(product)}
                      >
                        {product.productName}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              <div className="col-4 d-flex justify-content-around align-items-center">
                <Link
                  to="/bsk-user"
                  className="text-link header-text text-dark"
                >
                  <i
                    className="fa-regular fa-user fs-5"
                    style={{ cursor: "pointer" }}
                  ></i>
                </Link>

                <Link
                  to="/bskian-cart"
                  className="text-link header-text text-dark"
                >
                  <i
                    className="fa-solid fa-cart-shopping fs-5"
                    style={{ cursor: "pointer" }}
                  ></i>
                </Link>

                <Link
                  to="/bsk-wishlist"
                  className="text-link header-text text-dark"
                >
                  <i
                    className="fa-solid fa-heart fs-5"
                    style={{ cursor: "pointer" }}
                  ></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
